import { useSyncExternalStore } from 'react';

/**
 * How the project status badge shows the other contracts' statuses: "+N"
 * beside the badge, or "Stacked brickor", a stack of coloured layers under the
 * badge that fans out on hover. Chosen on the profile page and kept in this
 * browser, so every badge follows the choice at once.
 */
export type ContractStatusStyle = 'count' | 'stack';

const STORAGE_KEY = 'etappio-contract-status-style';
const listeners = new Set<() => void>();

const read = (): ContractStatusStyle => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === 'stack' ? 'stack' : 'count';
  } catch {
    return 'count';
  }
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  const onStorage = (event: StorageEvent) => { if (event.key === STORAGE_KEY) listener(); };
  window.addEventListener('storage', onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener('storage', onStorage);
  };
};

export function setContractStatusStyle(style: ContractStatusStyle) {
  try {
    window.localStorage.setItem(STORAGE_KEY, style);
  } catch {
    // Private mode or blocked storage: the choice is not kept.
  }
  listeners.forEach(listener => listener());
}

export function useContractStatusStyle(): ContractStatusStyle {
  return useSyncExternalStore(subscribe, read, () => 'count');
}
